import Vue from "vue";

export const TicketRecords = {
    methods: {

        //TODO: 获取安全确认票历史
        async getTicketRecords(obj) {
            let { pageSize, pageNum , name } = obj;

            let res = await this.$http.get("/tenant/confirm/vote/history/list", {
                name:name ?? '',
                pageSize: pageSize,
                pageNum: pageNum,
            });
            return res || [];
        },
        //TODO: 新增安全确认票历史
        async addTicketRecords(obj) {
            let res = await this.$http.post("/tenant/confirm/vote", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO:修改安全确认票历史
        async upTicketRecords(obj) {
            let res = await this.$http.put("/tenant/confirm/vote", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO:删除安全确认票历史
        async delTicketRecords(id) {
            let res = await this.$http.delete(`/tenant/confirm/vote/${id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },

        //TODO: 查看安全确认票历史详细
        async getTicketRecordsInfo(historyId) {
            let res = await this.$http.get(`/tenant/confirm/vote/history/info`,{
                historyId:historyId,
            });
          
            return res;
        },

        //TODO: 保存风险告知选中状态
        async saveRiskNotice(obj) {
            let res = await this.$http.put(`/tenant/confirm/vote/status/new`,obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        }
    },
};
